import { useQuery } from '@tanstack/react-query';
import { customersApi } from '../api/customersApi';

/**
 * Доступность источников метрики активности на уровне инсталляции.
 *
 * По ней гейтится пункт меню «Активность в интернете». Приём тот же, что у пункта
 * устройств (useDeviceNavigation): сайдбар берёт ответ ОДИН раз и держит в кеше
 * react-query — запроса на каждый рендер нет.
 *
 * Запрос уходит только при наличии права экрана: ручка закрыта customers.view,
 * и слать заведомый 403 незачем.
 */
export function useActivitySources(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['customers-activity', 'sources'],
    queryFn: () => customersApi.getActivitySources(),
    // Состав биллингов меняется настройкой, а не потоком событий: держим долго.
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
    retry: 1,
    enabled: options?.enabled ?? true,
  });
}
